import React from "react";

const HeroSection = () => {
  return (
    <>
      <div className="hidden md:block">
        <div className="my-8 hero-banner">
          <div className="mx-auto main-container">
            <div className="relative bottom-3">
              <div className="font-bold md:text-[48px] text-[32px] bold-font">
                Congratulations!
              </div>
              <div className="text-2xl font-normal mt-2 max-w-xl">
                You’re about to take your health to the next level with an
                <span className="gift-highlight">Exclusive FREE Gift</span> -
                But
                <span className="bold-font"> ONLY </span>
                for new customers!
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-8 bg-[#233751] text-center text-white pb-7 pt-5 mt-12 block md:hidden">
        <div className="mx-auto main-container">
          <div className="flex justify-center flex-col items-center">
            <div className="font-bold md:text-[48px] text-[32px]">
              Congratulations!
            </div>
            <div className="md:text-[24px] text-[21px] font-normal mt-2 max-w-xl px-4">
              You’re about to take your health to the next level with an
              <span className="gift-highlight">Exclusive FREE Gift</span> - But
              <span className="bold-font"> ONLY </span>
              for new customers!
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
